

export default {
  name: "ellipsis",
  nickname: "超出部分替换为省略号",
  desc: "当文字超出的时候，是否超出部分替换为省略号。",
  value: true,
  defaultValue: true,
  type: "object",
  props: {
    height: {
      name: "height",
      nickname: "高度",
      desc: "父节点标签区的高度。",
      value: 20,
      defaultValue: 20,
      type: "pureValue",
    },
  },
}
